import React from 'react';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import FaceIcon from '@mui/icons-material/Face';

/**
 * PersonAvatar - Displays a person's avatar with fallback to FaceIcon
 * @param {string} imageUrl - Full image URL (backend provides full URLs)
 * @param {string} name - Person's name (for alt text)
 * @param {number} size - Avatar size in pixels (default: 64)
 * @param {boolean} noMargin - If true, removes the margin-right (default: false)
 */
export default function PersonAvatar({ imageUrl, name = 'Unknown', size = 64, noMargin = false }) {
  const iconSize = Math.round(size * 0.625); // Icon is ~62.5% of avatar size
  const avatarSx = { width: size, height: size, ...(noMargin ? {} : { mr: 2 }) };

  // Backend provides full URLs - no conversion needed
  return imageUrl ? (
    <Avatar
      src={imageUrl}
      alt={name}
      sx={avatarSx}
    />
  ) : (
    <Avatar sx={avatarSx}>
      <FaceIcon sx={{ fontSize: iconSize }} />
    </Avatar>
  );
}
